<template>
  <div>
    <a-form labelAlign="left" layout="inline" :form="form">
      <a-form-item label="回复用户:">
        <a-input v-model="form.reply" />
      </a-form-item>
      <a-form-item label="回复时间：">
        <a-range-picker v-model="pickDate" />
      </a-form-item>
      <!-- <a-form-item label="内容类型：">
        <a-select allowClear v-model="form.type" style="width: 120px">
          <a-select-option
            v-for="item in LIKE_TYPE"
            :key="item.key"
            :value="item.key"
            :title="item.value"
          >
            {{ item.value }}
          </a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item label="审核状态：">
        <a-select allowClear v-model="form.check_status" style="width: 120px">
          <a-select-option
            v-for="item in CHECK_STATUS"
            :key="item.key"
            :value="item.key"
            :title="item.value"
          >
            {{ item.value }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="是否删除：">
        <a-select allowClear v-model="form.delete" style="width: 120px">
          <a-select-option
            v-for="item in DEL_STATUS"
            :key="item.key"
            :value="item.key"
            :title="item.value"
          >
            {{ item.value }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button @click="search" type="primary" style="margin-right: 10px">查询</a-button>
        <a-button @click="resetCondition">重置</a-button>
      </a-form-item>
    </a-form>
    <a-table
      @change="pageChange"
      :pagination="pagination"
      :columns="columns"
      :data-source="dataSource"
      :bordered="true"
      :loading="loading"
      rowKey="id"
      tableLayout="auto"
    >
      <template slot="type" slot-scope="text">
        {{ textFormat(text, 'LIKE_TYPE') }}
      </template>
      <template slot="is_del" slot-scope="text">
        {{ textFormat(text, 'DEL') }}
      </template>
      <template slot="approva_status" slot-scope="text">
        {{ textFormat(text, 'CHECK_STATUS') }}
      </template>
      <template slot="action" slot-scope="text,record">
        <a-popconfirm
          title="审核回复"
          @confirm="anditArticle(record.id, 1)"
          @cancel="anditArticle(record.id, 2)"
          ok-text="通过"
          cancel-text="驳回"
        >
          <a href="#">审核</a>
        </a-popconfirm>
        <a-button type="link" @click="$refs.viewDetail.open(record.id, 'review')" size="small">查看</a-button>
        <a-button v-if="record.is_del === '0'" @click="delItem(record.id, 1)" type="link" size="small">删除</a-button>
        <a-button v-else @click="delItem(record.id, 0)" type="link" size="small">恢复</a-button>
      </template>
    </a-table>
    <viewDetail ref="viewDetail" />
  </div>
</template>

<script>
import viewDetail from './components/commentDetail.vue'
import { reColumns } from './business/index'
import moment from 'moment'
import { mapState } from 'vuex'
import { reviewList, dealView } from '@/api/groupWeb/article'
import _ from 'lodash'
export default {
  components: { viewDetail },
  computed: {
    ...mapState(['label']),
    LIKE_TYPE() {
      return this.label?.data?.POSTS?.LIKE_TYPE || []
    },
    CHECK_STATUS() {
      return this.label?.data?.POSTS?.CHECK_STATUS || []
    },
    DEL_STATUS() {
      return this.label?.data?.POSTS?.DEL || []
    }
  },
  watch: {
    pickDate: {
      handler(val) {
        this.form.startTime = val.length ? moment(val[0]).format('YYYY-MM-DD') : ''
        this.form.endTime = val.length ? moment(val[1]).format('YYYY-MM-DD') : ''
      },
      immediate: true,
    },
  },
  data() {
    return {
      loading: false,
      columns: reColumns,
      dataSource: [],
      pickDate: [],
      form: {},
      condition: {},
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0,
        showQuickJumper: true,
      },
    }
  },
  methods: {
    pageChange(pagination) {
      this.pagination.page = pagination.current
      this.getList()
    },
    delItem(id, is_del) {
      this.$confirm({
        title: is_del === 1 ? '是否确定删除该评论？' : '是否确定恢复该评论？',
        okText: '确认',
        cancelText: '取消',
         onOk: async () => {
          const res = await dealView({ id, is_del })
          this.doingSuccess(res)
        }
      })
    },
    doingSuccess(res) {
      if (res.code === '000000') {
        this.$message.success('操作成功')
        this.getList()
      }
    },
    anditArticle(id, approva_status) {
      dealView({ id, approva_status }).then((res) => this.doingSuccess(res))
    },
    goReview(id) {
      this.$router.push({
        path: `/group-web/article/detail/${id}`,
      })
    },
    textFormat(text, key) {
      return this.label.data?.POSTS?.[key].find((d) => d.key === Number(text))?.value
    },
    resetCondition() {
      this.pickDate = []
      this.form = {}
      this.condition = {}
      this.search()
    },
    search() {
      this.pagination.page = 1
      this.pagination.pageSize = 20
      this.condition = _.cloneDeep(this.form)
      this.getList()
    },

    async getList() {
      const params = Object.assign({}, this.condition, {
        page: this.pagination.page,
        per_page: this.pagination.pageSize,
        parent_id: this.$route.params.id || ''
      })
      this.loading = true
      try {
        const { data } = await reviewList(params)
        this.pagination.pageSize = data?.pagination?.per_page || 20
        this.pagination.page = data?.pagination?.page || 1
        this.pagination.total = data?.pagination?.total || 0
        this.dataSource = data?.list
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    this.getList()
  },
}
</script>

<style lang="less" scoped>
</style>
